<template>
    <div>
        <p><strong>ИНН</strong></p>
        <p v-if="data.number"><strong>Номер:</strong> {{ data.number }}</p>
        <p v-if="data.issuedBy"><strong>Кем выдан:</strong> {{ data.issuedBy }}</p>
        <p v-if="data.supportingDoc"><strong>Документ:</strong> {{ data.supportingDoc }}</p>
    </div>
</template>

<script>
export default {
    name: "ExpertPanelReviewAboutInn",
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>

</style>